import Grid from '@material-ui/core/Grid'
import MuiAvatar from '@material-ui/core/Avatar'
import React, { useEffect, useState } from 'react'
import usePopover from '../../../../hooks/usePopover'
import ListItemTextBase from '../../../common/Containers/Base/ListItemTextBase'
import { ContextMenuListItem, Popover } from '../../../common/Dialogs/Popover'
import Typography from '../../../common/Typography'
import { useTrans } from '../../../../services/i18n'
import ArrowDropDown from '@material-ui/icons/ArrowDropDown'
import PersonOutlineIcon from '@material-ui/icons/PersonOutline'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'
import useStyles from '../styles'
import useLogout from '../../../../hooks/useLogout'
import connect from './connect'
import useUserFullName from '../../../../hooks/useUserFullName'
import { Divider } from '../../../common/Divider'
import { Link } from 'react-router-dom'
import packageJson from '../../../../../package.json'

const getDisplayAppVersion = appVersion => {
  if (!appVersion || appVersion === 'Unknown') {
    return packageJson.version
  }

  const releaseIndex = appVersion.indexOf('-release')

  if (releaseIndex === -1) {
    return packageJson.version
  }

  return `${packageJson.version}${appVersion.substring(releaseIndex)}`
}

const getInitials = value => {
  if (!value) {
    return ''
  }

  return value
    .split(' ')
    .filter(Boolean)
    .map(item => item.charAt(0))
    .join('')
    .substring(0, 2)
    .toUpperCase()
}

function UserMenu({ authUser, getTooltips }) {
  const styles = useStyles()
  const { trans } = useTrans()
  const [anchorEl, onOpenPopover, onClosePopover] = usePopover()
  const onLogout = useLogout()
  const fullName = useUserFullName(authUser)
  const [appVersion, setAppVersion] = useState(localStorage.getItem('appVersion'))

  useEffect(() => {
    getTooltips()
  }, [getTooltips])

  useEffect(() => {
    const onStorageChange = () => {
      setAppVersion(localStorage.getItem('appVersion'))
    }

    window.addEventListener('storage', onStorageChange)

    return () => {
      window.removeEventListener('storage', onStorageChange)
    }
  }, [])

  return (
    <>
      <Grid
        container
        alignItems="center"
        className={`${styles.avatarRoot} pointer`}
        onClick={onOpenPopover}
        wrap="nowrap"
      >
        <MuiAvatar className={styles.headerAvatar}>
          {getInitials(fullName)}
        </MuiAvatar>

        <Typography
          component="span"
          variant="body2"
          noWrap
          weight="bold"
          className={styles.avatarTitle}
        >
          {fullName}
        </Typography>

        <ArrowDropDown />
      </Grid>

      <Popover
        id="id-user-menu"
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={onClosePopover}
      >
        <div className={styles.userMenuHeader}>
          <Typography weight="bold" variant="body1">
            Account
          </Typography>

          <Typography variant="body2" color="hint">
            {authUser?.email}
          </Typography>
        </div>

        <Divider light spacing={1} />

        <ContextMenuListItem button component={Link} to="/profile" onClick={onClosePopover}>
          <PersonOutlineIcon className={styles.userMenuIcon} />
          <ListItemTextBase>{trans('My Profile')}</ListItemTextBase>
        </ContextMenuListItem>

        <ContextMenuListItem button onClick={onLogout}>
          <ExitToAppIcon className={styles.userMenuIcon} />
          <ListItemTextBase>{trans('logout')}</ListItemTextBase>
        </ContextMenuListItem>

        <Divider light spacing={1} />

        <div className={styles.userMenuVersion}>
          App Version: {getDisplayAppVersion(appVersion)}
        </div>
      </Popover>
    </>
  )
}

export default connect(UserMenu)